
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 68 68","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.353.226C2.21.912.611 2.606.113 4.721c-.208.88-.106 2.39.222 3.305.143.397.512 1.072.82 1.5.31.427 5.91 6.12 12.446 12.651l11.884 11.875-12.239 12.25C2.537 57.022.962 58.647.64 59.302c-.517 1.052-.695 1.918-.624 3.044.211 3.358 2.991 5.825 6.326 5.615 1.11-.07 2.123-.401 2.978-.974.332-.222 6.017-5.81 12.634-12.418l12.03-12.013 12.22 12.195C57.51 66.035 58.483 66.975 59.235 67.33c1.125.53 1.976.703 3.106.632 3.358-.212 5.825-2.991 5.615-6.326-.07-1.105-.407-2.142-.949-2.916-.208-.297-5.81-5.968-12.449-12.602l-12.07-12.06 12.163-12.19C67.753 8.737 67.331 9.2 67.794 7.423c.817-3.137-1.165-6.405-4.395-7.246-1.355-.353-2.816-.175-4.197.511-.527.262-3.04 2.708-12.935 12.594l-12.282 12.27-12.28-12.27C8.662.255 9.027.59 7.422.16c-.86-.23-2.238-.2-3.07.066z"}})])
          )
        }
      }
    